import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DOOD_API } from '@config/ws.config';
import { UpsellingData } from '@store/upselling/upselling.model';

@Injectable({ providedIn: 'root' })
export class UpsellingApiService {
  constructor(private client: HttpClient) {}

  /**
   * Loads upselling mappings for the current shop.
   * marketplaceId is the marketplace of the current journey. An empty value is
   * omitted so the API keeps using the shop default marketplace.
   */
  public getUpsellingProposals$({
    shopId,
    orderType,
    marketplaceId,
  }: {
    shopId: string;
    orderType: string;
    marketplaceId?: string;
  }): Observable<UpsellingData> {
    const queryParams = new URLSearchParams({
      shopId,
      orderType,
      ...(marketplaceId ? { marketplaceId } : {}),
    }).toString();

    return this.client.get<UpsellingData>(`${DOOD_API}/upselling/proposals?${queryParams}`);
  }
}
